import { Box, Button, Stack, Typography } from "@mui/material";

import { stringConstant } from "../utils/string-utils";
// import '../app/css/additional-styles/page-content.css'
import { useNavigate } from "react-router-dom";
import ModalVideo from "./modal-video";

export default function PageContent() {
    const navigate = useNavigate()
    const handleGetStartedClick = () => {
        navigate('/login');
    };

    return (

        <section>
            <div className="max-w-6xl mx-auto px-4 sm:px-6 relative">
                <div className="relative pt-32 pb-10 md:pt-40 md:pb-16">

                    {/* Section header */}
                    <div className="max-w-3xl mx-auto text-center pb-12 md:pb-16">
                        <h1 className="h1 mb-4" data-aos="fade-up">{stringConstant.DOWNLOAD_TITLE}</h1>
                        <p className="text-md text-gray-300 mb-8" data-aos="fade-up" data-aos-delay="200">{stringConstant.DOWNLOAD_BODY}</p>
                        <div className="max-w-xs mx-auto sm:max-w-none sm:flex sm:justify-center">
                            <div data-aos="fade-up" data-aos-delay="400">
                                <a className="btn text-white bg-purple-600 hover:bg-purple-700 w-full mb-4 sm:w-auto sm:mb-0" href="/login">Sign In</a>
                            </div>

                        </div>
                    </div>

                    <ModalVideo
                        thumb={'./images/thumbnail.png'}
                        thumbWidth={1024}
                        thumbHeight={576}
                        thumbAlt="Modal video thumbnail"
                        video="./videos/cocVideo.mp4"
                        videoWidth={1920}
                        videoHeight={1080} />

                </div>

            </div>
        </section>
    )
}
